import { Injectable } from "@angular/core";
import { RecycleBinElement } from "@data/course";
import { ServiceResponse } from "@data/response";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { ResponseHandler } from "@service/system/responseHandler.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable({
	providedIn: "root"
})
export class RecycleBinService {
	private _recycleBinURL = `${API_URL}/recyclebin`;

	constructor(private responseHandler: ResponseHandler, private httpManager: HttpManager) {}

	deleteAllRecycleBingElements(cvItemID: string, body: any): Observable<ServiceResponse<any>> {
		return this.responseHandler.httpPost<any>(`${this._recycleBinURL}/${cvItemID}/alldelete`, body);
	}

	deleteRecycleBingElementByID(cvItemID: string, id: string, table: string): Observable<ServiceResponse<any>> {
		const params = { id: id, table: table };
		return this.responseHandler.httpDelete<any>(`${this._recycleBinURL}/${cvItemID}/delete/${id}`, params);
	}

	getRecycleBinByGUID(CVItemID: string | string[]): Observable<ServiceResponse<RecycleBinElement[]>> {
		return this.responseHandler.httpGet<RecycleBinElement[]>(`${this._recycleBinURL}/${CVItemID}/find`, {
			CVItemID: CVItemID
		});
	}

	restoreAllRecycleBingElements(cvItemID: string, body: any): Observable<ServiceResponse<any>> {
		return this.responseHandler.httpPost<any>(`${this._recycleBinURL}/${cvItemID}/allrestore`, body);
	}

	restoreRecycleBingElementByID(cvItemID: string, id: string, table: string): Observable<ServiceResponse<any>> {
		const params = { id: id, table: table };
		return this.responseHandler.httpPost<any>(`${this._recycleBinURL}/${cvItemID}/restore/${id}`, null, params);
	}
}
